module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/sold-properties-3f42021611408aabc65a9c79e774c495.svg";